import Hex from './hex';
import Text from './text';

/**
 * The Text a fallback ItemRenderer shows its Item in.
 *
 * Shared by {@link DefaultListItemRenderer} and {@link DefaultSelectListItemRenderer}, which are the same row but for the selection one of them carries. They cannot inherit it from each other — one is a ListItemRenderer and the other a SelectListItemRenderer, and those are siblings — so the part that is genuinely the
 * same is a function both call rather than a shape both repeat.
 */
export default function defaultItemRendererText(): Text {
	const text = new Text();
	text.lineHeight = 20;
	text.fill = new Hex('#0E121B');
	text.fontSize = 14;
	text.fontWeight = 500;
	text.fontFamily = 'Inter';
	text.truncate = true;
	// the width the truncation needs something to be too narrow for. Filling the row says so outright
	// rather than leaving it to a hugging flex item happening to shrink, and it is what makes the text
	// take the whole row in a row wider than the text, so what is shown lines up with what is measured
	text.width = 'fill';
	return text;
}
